import { MyDigitsActionTypes } from "../actions/index.model";
import { LineDetails, Lines, MyDigitsState, UserDetails } from "./index.model";

import appService from "./../../service";
import { Category } from "app/utils/categories";
const userDetails: UserDetails = {
  email: "",
  firstName: "",
  lastName: "",
  orig_tmobileid: "",
};

const defaultState: MyDigitsState = {
  userDetails: userDetails,
  lineDetails: [],
  loading: true,
  lineDetailMainObject: [],
  count: 0,
  searchKey: "",
  selectedLineDetails: JSON.parse(
    sessionStorage.getItem("selectedLineDetails") || "{}"
  ),
  filterLinesCount: 0,
  assigneeMsisdn: "",
  isEligibilityLine: false,
  selectedTab: 0,
};

const filterLinedetails = (response: LineDetails[], key: string) => {
  let result: LineDetails[] = [];
  let count: number = 0;
  response.forEach((item: LineDetails) => {
    var lines = item.lines.filter(function (obj: Lines) {
      if (key[0] === "+") key = key.substring(1);
      const keyGroup = appService.returnMsisdnVariation(key);
      const formattedNumber = appService.formatPhoneNumber(obj.MSISDN);
      if (
        obj.givenName.toLowerCase().indexOf(key) !== -1 ||
        obj.MSISDN.toLowerCase().indexOf(keyGroup.realKey) !== -1 ||
        (keyGroup.formattedKey !== "" &&
          obj.MSISDN.toLowerCase().indexOf(keyGroup.formattedKey) !== -1)
      ) {
        return obj;
      } else if (formattedNumber.includes(key)) {
        return obj;
      } else {
        return "";
      }
    });
    count = count + lines.length;
    result.push({
      id: item.id,
      category: item.category,
      lines: lines,
      helpText: item.helpText,
    });
  });
  return { linesDetails: result, filterCount: count };
};

const setUnAssignedLine = (response: LineDetails[], msisdn: string) => {
  var assinedLines: any = [];
  response.forEach((data: any) => {
    if (data.id === Category.unAssignedID) {
      if (assinedLines.length > 0) {
        const lines = assinedLines.filter((line: Lines) => {
          return line.msisdn === msisdn;
        });

        if (lines.length > 0) {
          data.lines.push(lines[0]);
          data.lines = data.lines.sort((val1: any, val2: any) =>
            val1.givenName.toLowerCase() > val2.givenName.toLowerCase() ? 1 : -1
          );
        }
      }
    }
    if (data.id === Category.assignedID) {
      assinedLines = [...data.lines];
      const lines = data.lines.filter((line: Lines) => {
        return line.msisdn !== msisdn;
      });
      data.lines = lines;
    }
  });
  return response;
};

const setAssignedLine = (response: LineDetails[], msisdn: string) => {
  response.forEach((data: any) => {
    if (data.id === Category.assignedID) {
      let unAssignedLine = response.filter((unassgin) => {
        return unassgin.id === Category.unAssignedID;
      });
      if (unAssignedLine.length > 0 && unAssignedLine[0].lines.length > 0) {
        const lines = unAssignedLine[0].lines.filter((line: Lines) => {
          return line.msisdn === msisdn;
        });
        if (lines.length > 0) {
          data.lines.push(lines[0]);
          data.lines = data.lines.sort((val1: any, val2: any) =>
            val1.givenName.toLowerCase() > val2.givenName.toLowerCase() ? 1 : -1
          );
        }
      }
    }
    if (data.id === 3) {
      const lines = data.lines.filter((line: Lines) => {
        return line.msisdn !== msisdn;
      });
      data.lines = lines;
    }
  });
  return response;
};

const updatePairLineDetails=(lineDetails:any,action:any)=>{
  lineDetails
  .filter(
    (deviceType: LineDetails) => deviceType.id === Category.wearblesID
  )
  .map((data: LineDetails) => data.lines)
  .map((lines: Lines[]) =>
    lines.map((line: Lines) => {
      if (line.MSISDN === action.data.deviceNumber) {
        line.isPared = action.data.type === "unpair" ? false : true;
        line.pairedDevice =
          action.data.type === "unpair" ? "" : action.data.pairedDevice;
      }
    })
  );
  return lineDetails
}

const sortLinesName=(lines:any)=>{
  return lines.sort((val1: any, val2: any) =>
    val1.givenName.toLowerCase() > val2.givenName.toLowerCase() ? 1 : -1
  )
}

const handleUpdateLineDetails=(action:any,state:any)=>{
  let count = 0;
      let lineDetailsLength = state.lineDetails.length;
      action.data &&
        action.data.forEach((data: any) => {
          if (lineDetailsLength > 0) {
            const lines = state.lineDetails.filter((line: any) => {
              return line.id === data.id;
            });
            if (lines.length > 0) {
              data.lines = [...data.lines, ...lines[0].lines];
            }
          }
          data.lines = data.lines.sort((val1: any, val2: any) =>
            val1.givenName.toLowerCase() > val2.givenName.toLowerCase() ? 1 : -1
          );
          count = count + data.lines.length;
        });

        return {count,action}
}

const handleSetAssignedLine=(state:any,action:any)=>{
  const lines = setAssignedLine(state.lineDetailMainObject, action.data);
      const tempSelectedLine = { ...state.selectedLineDetails };
      if (tempSelectedLine.id) {
        lines.forEach((line) => {
          line.lines.forEach((data) => {
            if (data.MSISDN === tempSelectedLine.id) {
              tempSelectedLine.category = line.category;
              tempSelectedLine.categoryID = Category.assignedID;
              tempSelectedLine.lineType = data.LineType;
              sessionStorage.setItem(
                "selectedLineDetails",
                JSON.stringify(tempSelectedLine)
              );
            }
          });
        });
      }
      return {
        lines,tempSelectedLine,action
      }
}

const LineDetailsReducer = (
  state: MyDigitsState = defaultState,
  action: any
) => {
  switch (action.type) {
    case MyDigitsActionTypes.GET_LINE_DETAILS:
      return { ...state, loading: false };
    case MyDigitsActionTypes.UPDATE_PAIR_LINE:
      const lineDetails: LineDetails[] = updatePairLineDetails([...state.lineDetails],action);
     
      return {
        ...state,
        lineDetails: [...lineDetails],
      };
    case MyDigitsActionTypes.SET_SELECTED_LINE:
      sessionStorage.setItem(
        "selectedLineDetails",
        JSON.stringify(action.data)
      );
      return {
        ...state,
        selectedLineDetails: action.data,
      };
    case MyDigitsActionTypes.UPDATE_USER_INFO:
      return { ...state, userDetails: action.data, loading: false };
    case MyDigitsActionTypes.UPDATE_GIVEN_NAME:
      const tempLineDetails = [...state.lineDetails];
      const tempSelectedLineDetails = { ...state.selectedLineDetails };
      if (tempLineDetails.length > 0) {
        const categoryIndex = tempLineDetails.findIndex(
          (line: any) => line.id === action.data.categoryID
        );
        const lineIndex = tempLineDetails[categoryIndex].lines.findIndex(
          (currentLine: any) => {
            return currentLine.MSISDN === action.data.id;
          }
        );
        const tempData = { ...tempLineDetails[categoryIndex].lines[lineIndex] };
        tempData.givenName = action.data.givenName;
        tempLineDetails[categoryIndex].lines[lineIndex] = tempData;
        tempLineDetails.forEach((data) => {
          data.lines = sortLinesName(data.lines);
        });
      }
      if (tempSelectedLineDetails.id !== "") {
        sessionStorage.setItem(
          "selectedLineDetails",
          JSON.stringify({
            ...tempSelectedLineDetails,
            deviceName: action.data.givenName,
          })
        );
      }
      return {
        ...state,
        lineDetails: [...tempLineDetails],
        selectedLineDetails:
          tempSelectedLineDetails.id !== ""
            ? { ...tempSelectedLineDetails, deviceName: action.data.givenName }
            : { ...tempSelectedLineDetails },
      };
    case MyDigitsActionTypes.UPDATE_LINE_DETAILS: { 
      
        const lineDetailsData=handleUpdateLineDetails(action,state);
      return {
        ...state,
        lineDetails: [...lineDetailsData.action.data],
        lineDetailMainObject: [...lineDetailsData.action.data],
        loading: false,
        count: lineDetailsData.count,
        filterLinesCount: lineDetailsData.count,
        isEligibilityLine: lineDetailsData.count === 0,
      };
    }
    case MyDigitsActionTypes.FILTER_LINE_DETAILS: {
      const data = filterLinedetails(state.lineDetailMainObject, action.data);
      return {
        ...state,
        searchKey: action.data,
        lineDetails: data?.linesDetails,
        filterLinesCount: data?.filterCount,
        loading: false,
      };
    }
    case MyDigitsActionTypes.SET_ASSIGNED_LINE: {
      const lineDetails=handleSetAssignedLine(state,action);

      return {
        ...state,
        lineDetailMainObject: lineDetails.lines,
        lineDetails: lineDetails.lines,
        assigneeMsisdn: lineDetails.action.data,
        selectedLineDetails: { ...lineDetails.tempSelectedLine },
      };
    }
    case MyDigitsActionTypes.SET_UN_ASSIGNED_LINE: {
      const lines = setUnAssignedLine(state.lineDetailMainObject, action.data);
      const tempSelectedLine = { ...state.selectedLineDetails };
      if (tempSelectedLine.id) {
        lines.forEach((line) => {
          line.lines.forEach((data) => {
            if (data.MSISDN === tempSelectedLine.id) {
              tempSelectedLine.category = line.category;
              tempSelectedLine.categoryID = Category.unAssignedID;
              tempSelectedLine.lineType = data.LineType;
              sessionStorage.setItem(
                "selectedLineDetails",
                JSON.stringify(tempSelectedLine)
              );
            }
          });
        });
      }

      return {
        ...state,
        lineDetailMainObject: lines,
        lineDetails: lines,
        assigneeMsisdn: action.data,
        selectedLineDetails: { ...tempSelectedLine },
      };
    }
    case MyDigitsActionTypes.RESET_ASSIGNEE_MSISDN: {
      return {
        ...state,
        assigneeMsisdn: "",
      };
    }
    case MyDigitsActionTypes.RESET_LINE_DETAILS: {
      return {
        ...defaultState,
      };
    }
    case MyDigitsActionTypes.CHNAGE_TAB:
      return { ...state, selectedTab: action.data };
    default:
      return state;
  }
};
export default LineDetailsReducer;
